import { Editor } from "@tiptap/react";
import { Icon } from "../../Icons";

interface StaticToolbarProps {
  editor: Editor | null;
}

/**
 * Static toolbar that is always visible above the editor.
 * Provides formatting buttons: Bold, Italic, Underline, Strikethrough, Clear Formatting.
 */
export const StaticToolbar: React.FC<StaticToolbarProps> = ({ editor }) => {
  if (!editor) return null;

  return (
    <div className="indigo-tiptap-static-toolbar">
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={`indigo-tiptap-static-toolbar__button ${
          editor.isActive("bold") ? "is-active" : ""
        }`}
        title="Bold (⌘B)"
        aria-label="Bold"
      >
        <Icon name="bold" size="s" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={`indigo-tiptap-static-toolbar__button ${
          editor.isActive("italic") ? "is-active" : ""
        }`}
        title="Italic (⌘I)"
        aria-label="Italic"
      >
        <Icon name="italic" size="s" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={`indigo-tiptap-static-toolbar__button ${
          editor.isActive("underline") ? "is-active" : ""
        }`}
        title="Underline (⌘U)"
        aria-label="Underline"
      >
        <Icon name="underline" size="s" />
      </button>
      <button
        type="button"
        onClick={() => editor.chain().focus().toggleStrike().run()}
        className={`indigo-tiptap-static-toolbar__button ${
          editor.isActive("strike") ? "is-active" : ""
        }`}
        title="Strikethrough (⌘⇧S)"
        aria-label="Strikethrough"
      >
        <Icon name="strikethrough" size="s" />
      </button>
      <div className="indigo-tiptap-static-toolbar__separator" />
      <button
        type="button"
        onClick={() =>
          editor.chain().focus().unsetAllMarks().clearNodes().run()
        }
        className="indigo-tiptap-static-toolbar__button"
        title="Clear formatting"
        aria-label="Clear formatting"
      >
        <Icon name="clear-formatting" size="s" />
      </button>
    </div>
  );
};
